import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

let isRefreshing = false;

export const instance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Function to refresh the access token using the refresh token
async function refreshAccessToken() {
  if (isRefreshing) return undefined;
  isRefreshing = true;
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const token = localStorage.getItem("token");
    if (!refreshToken || !token) return undefined;

    const response = await axios.get(`${API_URL}/auth/refresh`, {
      headers: {
        "X-Auth-Token-Refresh": refreshToken,
        "X-Auth-Token": token,
        "Content-Type": "application/json;charset=UTF-8",
      },
    });
    const { authToken, refreshToken: newRefreshToken } = response.data;
    localStorage.setItem("token", authToken);
    localStorage.setItem("refreshToken", newRefreshToken);
    return authToken;
  } catch (error) {
    console.log(error);
    return undefined;
  } finally {
    isRefreshing = false;
  }
}

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["X-Auth-Token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token expiration
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const { data } = error.response
      ? error.response
      : { status: null, data: null };
    if (
      error.response &&
      error.response.status === 401 &&
      data.data === "TokenExpiredError"
    ) {
      // Token has expired; attempt to refresh it
      const newAccessToken = await refreshAccessToken();
      if (newAccessToken) {
        const originalRequest = error.config;
        originalRequest.headers["X-Auth-Token"] = newAccessToken;
        return axios(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);
